"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewFavorite = exports.viewActionButton = exports.userNotLoggedChat = exports.updateLastSeen = exports.updateChatMessagesLoaded = exports.updateChatListPosition = exports.updateChatLastSeen = exports.unsetFocusChatInput = exports.unselectFavoriteError = exports.unselectFavorite = exports.tabChatClick = exports.startLoadChats = exports.setFocusChatInput = exports.selectFavoriteError = exports.selectFavorite = exports.sameUserChat = exports.removeCurrentChat = exports.removeChat = exports.receiveChats = exports.onboardingFavorite = exports.myShoppingTabClick = exports.mySalesTabClick = exports.loadUserNotLogged = exports.loadChatsStart = exports.loadChatsError = exports.loadChatStart = exports.loadChatSameUser = exports.loadChatError = exports.loadChatDone = exports.loadChat = exports.loadChangeCurrentChatPosition = exports.loadChangeCurrentChat = exports.joinRoomStart = exports.joinRoomError = exports.joinRoomDone = exports.getChats = exports.getChat = exports.focusChatInputDone = exports.focusChatInput = exports.favoriteChat = exports.extractInfo = exports.disconnect = exports.currentChatIsLoaded = exports.createRoom = exports.closeOnboardingFavorite = exports.closeChat = exports.clickTabFavorite = exports.clickChatTabFavorite = exports.clickAllTab = exports.clickActionButton = exports.changeListPosition = exports.changeCurrentChatPosition = exports.changeCurrentChat = exports.autoLoadChatsError = exports.archivedTabClick = exports.allTabView = exports.allTabClick = exports.addButtons = void 0;
var _reactDom = _interopRequireDefault(require("react-dom"));
var _client = require("@apollo/client");
var _types = require("./types");
var _selectors = require("../selectors");
var _chatUtil = require("../helpers/chatUtil");
var _errorActions = require("./errorActions");
var _partnersActions = require("./partnersActions");
var _messagesActions = require("./messagesActions");
var _platform = require("../helpers/platform");
var _linking = require("../helpers/linking");
var _exceptions = require("../exceptions");
var _timeUtil = require("../helpers/timeUtil");
var _currentVersion = require("../helpers/currentVersion");
var _init = require("../helpers/apollo/init");
var _excluded = ["sellerName", "buyerName"];
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
// ====================================================================
// Typed actions
// ====================================================================

var favoriteChat = exports.favoriteChat = function favoriteChat(chat) {
  return {
    type: _types.FAVORITE_CHAT,
    value: {
      chat: chat
    }
  };
};
var loadChangeCurrentChat = exports.loadChangeCurrentChat = function loadChangeCurrentChat(chat) {
  return {
    type: _types.CHANGE_CURRENT_CHAT,
    value: {
      chat: chat
    }
  };
};
var loadChangeCurrentChatPosition = exports.loadChangeCurrentChatPosition = function loadChangeCurrentChatPosition(currentChatPosition) {
  return {
    type: _types.CHANGE_CURRENT_CHAT_POSITION,
    value: {
      currentChatPosition: currentChatPosition
    }
  };
};
var loadChatStart = exports.loadChatStart = function loadChatStart() {
  return {
    type: _types.LOAD_CHAT_START
  };
};
var loadChatDone = exports.loadChatDone = function loadChatDone(chat, partner) {
  return {
    type: _types.LOAD_CHAT_DONE,
    value: {
      chat: chat,
      partners: [partner]
    }
  };
};
var loadChatError = exports.loadChatError = function loadChatError(reason) {
  var chat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var partner = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: _types.LOAD_CHAT_ERROR,
    value: {
      chat: chat,
      reason: reason,
      partners: [partner]
    }
  };
};
var joinRoomStart = exports.joinRoomStart = function joinRoomStart() {
  return {
    type: _types.JOIN_ROOM_START
  };
};
var joinRoomDone = exports.joinRoomDone = function joinRoomDone(chat) {
  var partner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: _types.JOIN_ROOM_DONE,
    value: {
      chat: chat,
      partners: [partner]
    }
  };
};
var joinRoomError = exports.joinRoomError = function joinRoomError(reason) {
  return {
    type: _types.JOIN_ROOM_ERROR,
    value: {
      reason: reason
    }
  };
};
var removeChat = exports.removeChat = function removeChat(roomname) {
  return {
    type: _types.REMOVE_CHAT,
    value: {
      roomname: roomname
    }
  };
};
var addButtons = exports.addButtons = function addButtons(roomname, buttons) {
  return {
    type: _types.ADD_BUTTONS,
    value: {
      roomname: roomname,
      buttons: buttons
    }
  };
};
var loadChat = exports.loadChat = function loadChat() {
  return {
    type: _types.UI.LIST_MESSAGES
  };
};
var loadUserNotLogged = exports.loadUserNotLogged = function loadUserNotLogged() {
  return {
    type: _types.UI.USER_NOT_LOGGED
  };
};
var loadChatSameUser = exports.loadChatSameUser = function loadChatSameUser() {
  return {
    type: _types.UI.USER_AD
  };
};
var setFocusChatInput = exports.setFocusChatInput = function setFocusChatInput() {
  return {
    type: _types.UI.FOCUS_CHAT_INPUT
  };
};
var unsetFocusChatInput = exports.unsetFocusChatInput = function unsetFocusChatInput() {
  return {
    type: _types.UI.LIST_MESSAGES
  };
};
var updateChatLastSeen = exports.updateChatLastSeen = function updateChatLastSeen(roomname) {
  return {
    type: _types.UPDATE_CHAT_LAST_SEEN,
    value: {
      roomname: roomname
    }
  };
};
var updateChatMessagesLoaded = exports.updateChatMessagesLoaded = function updateChatMessagesLoaded(roomname) {
  return {
    type: _types.UPDATE_CHAT_MESSAGES_LOADED,
    value: {
      roomname: roomname
    }
  };
};
var loadReceiveChats = function loadReceiveChats(chats, partners) {
  return {
    type: _types.RECEIVE_CHATS,
    value: {
      chats: chats,
      partners: partners
    }
  };
};
var loadChatsStart = exports.loadChatsStart = function loadChatsStart() {
  return {
    type: _types.LOAD_CHATS_START
  };
};
var loadChatsDone = function loadChatsDone() {
  return {
    type: _types.LOAD_CHATS_DONE
  };
};
var loadChatsError = exports.loadChatsError = function loadChatsError(reason) {
  return {
    type: _types.LOAD_CHATS_ERROR,
    value: {
      reason: reason
    }
  };
};
var changeListPosition = exports.changeListPosition = function changeListPosition(position) {
  return {
    type: _types.UPDATE_LIST_POSITION,
    value: _objectSpread({}, position)
  };
};

// ====================================================================
// Functions actions
// ====================================================================

var changeCurrentChat = exports.changeCurrentChat = function changeCurrentChat(chat) {
  return function (dispatch) {
    dispatch(loadChangeCurrentChat(chat));
  };
};
var changeCurrentChatPosition = exports.changeCurrentChatPosition = function changeCurrentChatPosition(currentChatPosition) {
  return function (dispatch) {
    dispatch(loadChangeCurrentChatPosition(currentChatPosition));
  };
};
var currentChatIsLoaded = exports.currentChatIsLoaded = function currentChatIsLoaded(roomname) {
  return function (dispatch) {
    if (roomname !== null) {
      dispatch(updateLastSeen());
    }
  };
};
var userNotLoggedChat = exports.userNotLoggedChat = function userNotLoggedChat() {
  return function (dispatch, getState, _ref) {
    var Lurker = _ref.Lurker;
    var _getState = getState(),
      renderProps = _getState.renderProps;
    var _renderProps$listId = renderProps.listId,
      listId = _renderProps$listId === void 0 ? '' : _renderProps$listId;
    if (listId) {
      Lurker.viewOpenChatWithNotLoggedUser();
    } else {
      Lurker.viewChatListWithNotLoggedUser();
    }
    dispatch(loadUserNotLogged());
  };
};
var sameUserChat = exports.sameUserChat = function sameUserChat() {
  return function (dispatch, _, _ref2) {
    var Lurker = _ref2.Lurker;
    Lurker.viewOpenChatSuccessful();
    dispatch(loadChatSameUser());
  };
};
var focusChatInput = exports.focusChatInput = function focusChatInput() {
  return function (dispatch) {
    dispatch(setFocusChatInput());
  };
};
var focusChatInputDone = exports.focusChatInputDone = function focusChatInputDone() {
  return function (dispatch) {
    dispatch(unsetFocusChatInput());
  };
};
var closeChat = exports.closeChat = function closeChat(headerButton) {
  return function (dispatch, _, _ref3) {
    var RenderProps = _ref3.RenderProps;
    if (_platform.isMsite) {
      var _RenderProps$function = RenderProps.functions,
        functions = _RenderProps$function === void 0 ? {} : _RenderProps$function;
      dispatch(closeFromMsite());
      if (!functions.close) {
        headerButton && window.history.back();
      }
    } else {
      dispatch(closeFromWeb());
    }
  };
};
var closeFromMsite = function closeFromMsite() {
  return function (dispatch, getState, _ref4) {
    var RenderProps = _ref4.RenderProps;
    var _getState2 = getState(),
      currentChat = _getState2.currentChat;
    var _RenderProps$function2 = RenderProps.functions,
      functions = _RenderProps$function2 === void 0 ? {} : _RenderProps$function2;
    if (functions.close) {
      dispatch(closeFromWeb());
    } else if (currentChat) {
      dispatch(backToChatList());
    }
  };
};
var closeFromWeb = function closeFromWeb() {
  return function (_, __, _ref5) {
    var RenderProps = _ref5.RenderProps,
      ChatSDK = _ref5.ChatSDK,
      Lurker = _ref5.Lurker;
    var _RenderProps$function3 = RenderProps.functions,
      functions = _RenderProps$function3 === void 0 ? {} : _RenderProps$function3,
      container = RenderProps.container;
    var close = functions.close;
    Lurker.clickCloseChat();
    if (close) {
      close();
    }
    if (typeof container !== 'undefined') {
      _reactDom["default"].unmountComponentAtNode(container);
    }
    if (ChatSDK) {
      ChatSDK.disconnect();
    }
  };
};
var backToChatList = function backToChatList() {
  return function (dispatch, getState, _ref6) {
    var Lurker = _ref6.Lurker;
    var state = getState();
    var activeTab = (0, _selectors.activeChatTab)(state);
    var isFavorite = activeTab === '2';
    Lurker.clickChatList(isFavorite);
    dispatch(changeCurrentChat(null));
  };
};
var myShoppingTabClick = exports.myShoppingTabClick = function myShoppingTabClick() {
  return function (dispatch, _, _ref7) {
    var Lurker = _ref7.Lurker;
    Lurker.myShoppingTabClick();
    Lurker.myShoppingTabView();
  };
};
var mySalesTabClick = exports.mySalesTabClick = function mySalesTabClick() {
  return function (dispatch, _, _ref8) {
    var Lurker = _ref8.Lurker;
    Lurker.mySalesTabClick();
    Lurker.mySalesTabView();
  };
};
var archivedTabClick = exports.archivedTabClick = function archivedTabClick() {
  return function (dispatch, _, _ref9) {
    var Lurker = _ref9.Lurker;
    Lurker.archivedTabClick();
    Lurker.archivedTabView();
  };
};
var allTabClick = exports.allTabClick = function allTabClick() {
  return function (dispatch, _, _ref10) {
    var Lurker = _ref10.Lurker;
    Lurker.allTabClick();
    Lurker.allTabView();
  };
};
var allTabView = exports.allTabView = function allTabView() {
  return function (dispatch, _, _ref11) {
    var Lurker = _ref11.Lurker;
    Lurker.allTabView();
  };
};

// Favorite Chat

var viewFavorite = exports.viewFavorite = function viewFavorite() {
  return function (dispatch, _, _ref12) {
    var Lurker = _ref12.Lurker;
    Lurker.viewFavorite();
  };
};
var selectFavorite = exports.selectFavorite = function selectFavorite() {
  return function (dispatch, _, _ref13) {
    var Lurker = _ref13.Lurker;
    Lurker.selectFavorite();
  };
};
var unselectFavorite = exports.unselectFavorite = function unselectFavorite() {
  return function (dispatch, _, _ref14) {
    var Lurker = _ref14.Lurker;
    Lurker.unselectFavorite();
  };
};

// Foi removido?
var selectFavoriteError = exports.selectFavoriteError = function selectFavoriteError() {
  return function (dispatch, _, _ref15) {
    var Lurker = _ref15.Lurker;
    Lurker.selectFavoriteError();
  };
};

// Foi removido?
var unselectFavoriteError = exports.unselectFavoriteError = function unselectFavoriteError() {
  return function (dispatch, _, _ref16) {
    var Lurker = _ref16.Lurker;
    Lurker.unselectFavoriteError();
  };
};
var onboardingFavorite = exports.onboardingFavorite = function onboardingFavorite() {
  return function (dispatch, _, _ref17) {
    var Lurker = _ref17.Lurker;
    Lurker.onboardingFavorite();
  };
};
var closeOnboardingFavorite = exports.closeOnboardingFavorite = function closeOnboardingFavorite() {
  return function (dispatch, _, _ref18) {
    var Lurker = _ref18.Lurker;
    Lurker.closeOnboardingFavorite();
  };
};
var clickTabFavorite = exports.clickTabFavorite = function clickTabFavorite() {
  return function (dispatch, _, _ref19) {
    var Lurker = _ref19.Lurker;
    Lurker.clickTabFavorite();
  };
};
var clickChatTabFavorite = exports.clickChatTabFavorite = function clickChatTabFavorite() {
  return function (dispatch, _, _ref20) {
    var Lurker = _ref20.Lurker;
    Lurker.clickChatTabFavorite();
  };
};
var clickAllTab = exports.clickAllTab = function clickAllTab() {
  return function (dispatch, _, _ref21) {
    var Lurker = _ref21.Lurker;
    Lurker.clickAllTab();
  };
};
var tabChatClick = exports.tabChatClick = function tabChatClick(tab) {
  return function (dispatch, _, _ref22) {
    var Lurker = _ref22.Lurker;
    var tabValue = '';
    if (tab === '1') {
      tabValue = 'todas';
    }
    if (tab === '2') {
      tabValue = 'meus_favoritos';
    }
    if (tab === '3') {
      tabValue = 'minhas_compras';
    }
    if (tab === '4') {
      tabValue = 'minhas_vendas';
    }
    if (tab === '5') {
      tabValue = 'arquivadas';
    }
    Lurker.clickOpenChatMessages(tab === '2');
    Lurker.tabChatClick(tabValue);
  };
};
var createRoom = exports.createRoom = function createRoom() {
  var sendLurkerEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (dispatch, getState, _ref23) {
    var ChatSDK = _ref23.ChatSDK,
      Lurker = _ref23.Lurker,
      DataLayer = _ref23.DataLayer;
    var _getState3 = getState(),
      renderProps = _getState3.renderProps;
    var listId = renderProps.listId,
      user = renderProps.user,
      initialMessage = renderProps.initialMessage;
    if (!ChatSDK || !listId) {
      return Promise.reject();
    }
    var startTime = (0, _timeUtil.monotonicNow)();
    dispatch(loadChatStart());
    return ChatSDK.createRoom(listId, _currentVersion.versionWithPlatform).then(function (item) {
      Lurker.clickOpenChatAdView();
      var _extractInfo = extractInfo(item),
        partner = _extractInfo.partner,
        chat = _extractInfo.chat;
      var sellerId = chat.sellerId,
        roomname = chat.roomname,
        lastMessage = chat.lastMessage,
        olxPay = chat.olxPay;
      var isMyAd = sellerId === user;
      if (sendLurkerEvents) {
        var microsecondDiff = (0, _timeUtil.monotonicDiff)(startTime);
        Lurker.viewOpenChatSuccessful(chat, microsecondDiff);
      }
      if (!lastMessage) {
        DataLayer.openChatFirstTime(chat);
      }
      dispatch(updateChatMessagesLoaded(roomname));
      dispatch(isMyAd ? loadChatError(_types.REASON.USER_AD, chat, partner) : loadChatDone(chat, partner));
      dispatch((0, _partnersActions.startWatchingPartners)());
      if (initialMessage) {
        dispatch((0, _messagesActions.sendInitialMessage)());
      }
      dispatch((0, _messagesActions.getButtons)(roomname, olxPay));
      return chat;
    })["catch"](function (ex) {
      var message = ex.message,
        _ex$chat = ex.chat,
        chatItem = _ex$chat === void 0 ? {} : _ex$chat;
      var _extractInfo2 = extractInfo(chatItem),
        partner = _extractInfo2.partner,
        chat = _extractInfo2.chat;
      var roomname = chat.roomname;
      var BANNED = _types.PARTNERS_STATUS.BANNED,
        BLOCKED = _types.PARTNERS_STATUS.BLOCKED,
        DENOUNCED = _types.PARTNERS_STATUS.DENOUNCED,
        VALIDATING_PROFILE = _types.PARTNERS_STATUS.VALIDATING_PROFILE;
      var microsecondDiff = (0, _timeUtil.monotonicDiff)(startTime);
      var actionType;
      var messagesLoaded = true;
      switch (message) {
        case 'USER_IS_BANNED':
          actionType = loadChatDone(chat, _objectSpread(_objectSpread({}, partner), {}, {
            status: BANNED
          }));
          Lurker.viewOpenChatSuccessful(chat, microsecondDiff);
          Lurker.viewOpenChatWithBannedUser(chat);
          break;
        case 'USER_IS_VALIDATING_PROFILE':
          actionType = loadChatDone(chat, _objectSpread(_objectSpread({}, partner), {}, {
            status: VALIDATING_PROFILE
          }));
          Lurker.viewOpenChatSuccessful(chat, microsecondDiff);
          Lurker.viewOpenChatWithValidatingProfileUser(chat);
          break;
        case 'USER_IS_BLOCKED':
          actionType = loadChatDone(chat, _objectSpread(_objectSpread({}, partner), {}, {
            status: BLOCKED
          }));
          Lurker.viewOpenChatSuccessful(chat, microsecondDiff);
          Lurker.viewOpenChatWithBlockedUser(chat);
          break;
        case 'USER_IS_BLOCKED_BY_DENOUNCE':
          actionType = loadChatDone(chat, _objectSpread(_objectSpread({}, partner), {}, {
            status: DENOUNCED
          }));
          Lurker.viewOpenChatSuccessful(chat, microsecondDiff);
          Lurker.viewOpenChatWithBlockedUser(chat);
          break;
        case _types.REASON.EXPIRED_AD:
        case 'EMPTY_SEARCH_RESPONSE':
          actionType = loadChatError(_types.REASON.EXPIRED_AD, chat, partner);
          Lurker.viewOpenChatSuccessful(chat, microsecondDiff);
          Lurker.viewOpenChatOnExpiredAd(chat);
          break;
        case _types.REASON.CHAT_DISABLED:
          actionType = loadChatError(_types.REASON.CHAT_DISABLED, chat, partner);
          Lurker.viewOpenChatSuccessful(chat, microsecondDiff);
          Lurker.viewOpenChatWithUserWithChatDisabled(chat);
          break;
        case 'SAME_USER':
          actionType = sameUserChat();
          break;
        case _types.REASON.NO_INTERNET:
          actionType = loadChatError(_types.REASON.NO_INTERNET, chat, partner);
          Lurker.viewOpenChatWithNoInternet(chat);
          messagesLoaded = false;
          break;
        case _types.REASON.UNVERIFIED_PHONE:
          Lurker.viewOpenChatWithUnverifiedPhone(chat);
          return (0, _linking.openPhoneValidationLink)(listId);
        default:
          actionType = (0, _errorActions.handleError)(new _exceptions.CreateRoomException(ex));
          Lurker.viewOpenChatFailure(chat, ex, microsecondDiff);
          messagesLoaded = false;
          break;
      }
      if (messagesLoaded) {
        dispatch(updateChatMessagesLoaded(roomname));
      }
      return dispatch(actionType);
    });
  };
};
var disconnect = exports.disconnect = function disconnect() {
  return function (_, __, _ref24) {
    var ChatSDK = _ref24.ChatSDK;
    if (ChatSDK) {
      ChatSDK.disconnect();
    }
  };
};
var updateLastSeen = exports.updateLastSeen = function updateLastSeen() {
  return function (dispatch, getState, _ref25) {
    var ChatSDK = _ref25.ChatSDK;
    var roomname = (0, _selectors.getCurrentRoomname)(getState());
    var unreadMessages = (0, _selectors.getUnreadMessages)(getState());
    if (unreadMessages.length) {
      ChatSDK.updateLastSeen(roomname, unreadMessages)["catch"](function (ex) {
        dispatch((0, _errorActions.handleError)(new _exceptions.UpdateLastSeenException(ex)));
      });
    }
    dispatch(updateChatLastSeen(roomname));
  };
};
var removeCurrentChat = exports.removeCurrentChat = function removeCurrentChat(roomname) {
  return function (dispatch) {
    dispatch(removeChat(roomname));
    if (!_platform.isMsite) {
      dispatch(removeCurrentChatFromWeb(roomname));
    } else {
      dispatch(removeCurrentChatFromMsite());
    }
  };
};
var removeCurrentChatFromWeb = function removeCurrentChatFromWeb() {
  return function (dispatch, getState) {
    var _getNextCurrentChat = (0, _selectors.getNextCurrentChat)(getState()),
      nextChat = _getNextCurrentChat.nextChat,
      chatIndex = _getNextCurrentChat.chatIndex;
    dispatch(changeCurrentChatPosition(chatIndex));
    dispatch(changeCurrentChat(nextChat));
  };
};
var removeCurrentChatFromMsite = function removeCurrentChatFromMsite() {
  return function (dispatch) {
    dispatch(changeCurrentChatPosition(null));
    dispatch(changeCurrentChat(null));
  };
};
var updateChatListPosition = exports.updateChatListPosition = function updateChatListPosition(listPosition) {
  return function (dispatch) {
    dispatch(changeListPosition({
      chatList: listPosition
    }));
  };
};
var getChats = exports.getChats = function getChats(before, skipSendEvent) {
  return function (dispatch, getState, _ref26) {
    var Lurker = _ref26.Lurker;
    dispatch(loadChatsStart());
    var client = (0, _init.initApollo)();
    var state = getState();
    var activeTab = (0, _selectors.activeChatTab)(state);
    var isFavorite = activeTab === '2';
    return new Promise(function (resolve, reject) {
      client.query({
        query: (0, _client.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            query GetChats($before: DateTime) {\n              serverTimestamp\n              chats(fetchInactives: true, before: $before) {\n                # Chat\n                roomname\n                seen\n                lastMessage\n                lastMessageAt\n                lastMessageBy\n                favorite\n                # Users\n                userId # Old username\n                seller {\n                  id # Old sellerId\n                  name # Old sellerName\n                }\n                buyer {\n                  id # Old buyerId\n                  name # Old buyerName\n                }\n                # Ad\n                ad {\n                  listId\n                  status\n                  category\n                  olxPay\n                  subject\n                  image\n                  price\n                }\n              }\n            }\n          "]))),
        variables: {
          before: before
        },
        fetchPolicy: 'network-only'
      }).then(function (_ref27) {
        var _data$chats;
        var data = _ref27.data,
          errors = _ref27.errors;
        if (errors && errors.length > 0) {
          throw new Error(errors[0].message);
        }
        if (!data) {
          throw new Error('QUERY_ERROR');
        }
        var chats = (0, _chatUtil.parseChats)((_data$chats = data.chats) !== null && _data$chats !== void 0 ? _data$chats : [], data.serverTimestamp);
        if (!skipSendEvent) {
          Lurker.viewChatListSuccessful(isFavorite);
        }
        dispatch(receiveChats(chats));
        resolve(chats);
      })["catch"](function (ex) {
        if (ex.message === 'USER_NOT_IDENTIFIED') {
          dispatch((0, _errorActions.handleError)(new _exceptions.AuthException(ex)));
        } else {
          dispatch((0, _errorActions.handleError)(new _exceptions.LoadChatsException(ex)));
          if (!skipSendEvent) {
            Lurker.viewChatListFailure(ex, isFavorite);
          }
        }
        reject(ex);
      });
    });
  };
};
var getChat = exports.getChat = function getChat(roomname) {
  return function (dispatch) {
    var client = (0, _init.initApollo)();
    client.query({
      query: (0, _client.gql)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        query GetChat($roomname: String) {\n          serverTimestamp\n          chat(roomname: $roomname) {\n            # Chat\n            roomname\n            seen\n            lastMessage\n            lastMessageAt\n            lastMessageBy\n            # Users\n            userId # Old username\n            seller {\n              id # Old sellerId\n              name # Old sellerName\n            }\n            buyer {\n              id # Old buyerId\n              name # Old buyerName\n            }\n            # Ad\n            ad {\n              listId\n              status\n              category\n              olxPay\n              subject\n              image\n              price\n            }\n          }\n        }\n      "]))),
      variables: {
        roomname: roomname
      },
      fetchPolicy: 'network-only'
    }).then(function (_ref28) {
      var data = _ref28.data,
        errors = _ref28.errors;
      if (errors || !data) {
        throw new Error('QUERY_ERROR');
      }
      if (!data.chat) {
        return;
      }
      var chats = (0, _chatUtil.parseChats)([data.chat], data.serverTimestamp);
      dispatch(receiveChats(chats));
    })["catch"](function (ex) {
      dispatch((0, _errorActions.handleError)(new _exceptions.GetChatException(ex)));
    });
  };
};
var autoLoadChatsError = exports.autoLoadChatsError = function autoLoadChatsError(ex) {
  return function (dispatch, _, _ref29) {
    var Lurker = _ref29.Lurker;
    if (ex.message !== 'NO_INTERNET') {
      Lurker.autoLoadChatsError(ex);
      dispatch((0, _errorActions.handleError)(new _exceptions.AutoLoadChatsException(ex)));
    }
  };
};
var receiveChats = exports.receiveChats = function receiveChats(items) {
  return function (dispatch, getState, _ref30) {
    var Lurker = _ref30.Lurker;
    var state = getState();
    var activeTab = (0, _selectors.activeChatTab)(state);
    var isFavorite = activeTab === '2';
    var _extractInfos = extractInfos(items),
      chats = _extractInfos.chats,
      partners = _extractInfos.partners;
    var _getState4 = getState(),
      currentChat = _getState4.currentChat;
    dispatch(loadReceiveChats(chats, partners));
    if (!currentChat && !_platform.isMsite) {
      var first = (0, _chatUtil.getFirstByLastMessage)(chats);
      if (first) {
        dispatch(changeCurrentChat(first));
        dispatch(changeCurrentChatPosition(0));
        Lurker.clickOpenChatMessages(isFavorite);
      }
    }
    dispatch(loadChatsDone());
  };
};
var startLoadChats = exports.startLoadChats = function startLoadChats() {
  return function (dispatch, getState, _ref31) {
    var Lurker = _ref31.Lurker;
    var state = getState();
    var activeTab = (0, _selectors.activeChatTab)(state);
    var isFavorite = activeTab === '2';
    if ((0, _selectors.alreadyLoadedChats)(state)) {
      Lurker.viewChatListSuccessful(isFavorite);
    } else {
      dispatch(getChats())["catch"](function (_) {
        return _;
      });
    }
  };
};
var clickActionButton = exports.clickActionButton = function clickActionButton(objectDetails) {
  return function (dispatch, _, _ref32) {
    var Lurker = _ref32.Lurker;
    Lurker.clickActionButton(objectDetails);
  };
};
var viewActionButton = exports.viewActionButton = function viewActionButton(objectDetails) {
  return function (dispatch, _, _ref33) {
    var Lurker = _ref33.Lurker;
    Lurker.viewActionButton(objectDetails);
  };
};
var extractInfos = function extractInfos(items) {
  return items.reduce(function (acc, item) {
    var _acc$partners = acc.partners,
      partners = _acc$partners === void 0 ? [] : _acc$partners,
      _acc$chats = acc.chats,
      chats = _acc$chats === void 0 ? [] : _acc$chats;
    var _extractInfo3 = extractInfo(item),
      me = _extractInfo3.me,
      partner = _extractInfo3.partner,
      chat = _extractInfo3.chat;
    return {
      me: me,
      partners: [partner].concat(_toConsumableArray(partners)),
      chats: [chat].concat(_toConsumableArray(chats))
    };
  }, {});
};
var extractInfo = exports.extractInfo = function extractInfo(_ref34) {
  var sellerName = _ref34.sellerName,
    buyerName = _ref34.buyerName,
    chat = _objectWithoutProperties(_ref34, _excluded);
  var username = chat.username,
    sellerId = chat.sellerId,
    buyerId = chat.buyerId,
    adStatus = chat.adStatus,
    roomname = chat.roomname,
    buyerPublicAccountId = chat.buyerPublicAccountId,
    sellerPublicAccountId = chat.sellerPublicAccountId;
  var me = {};
  var partner = {};
  if (sellerId && username === sellerId) {
    me = {
      id: sellerPublicAccountId,
      name: sellerName
    };
    partner = {
      id: buyerPublicAccountId,
      name: buyerName,
      adStatus: adStatus,
      roomname: roomname
    };
  } else if (buyerId && username === buyerId) {
    me = {
      id: buyerPublicAccountId,
      name: buyerName
    };
    partner = {
      id: sellerPublicAccountId,
      name: sellerName,
      adStatus: adStatus,
      roomname: roomname
    };
  }
  return {
    me: me,
    partner: partner,
    chat: chat
  };
};